import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { SbEditorComponent } from './sb-editor.component';
import { SitesBuilderLibModule } from '@3ddv/ngx-sites-builder-lib';
import { SbEditorSidebarModule } from "./sb-editor-sidebar/sb-editor-sidebar.module";
import { SbEditorToolsModule } from "./sb-editor-tools/sb-editor-tools.module";
import { SaveMinisiteComponent } from './modals/save-minisite/save-minisite.component';
import { CredentialsComponent } from './modals/credentials/credentials.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { SiteCopyComponent } from './modals/site-copy/site-copy.component';
import { RedirectModalComponent } from './modals/redirect-modal/redirect-modal.component';

@NgModule({
    declarations: [
        SbEditorComponent,
        SaveMinisiteComponent,
        CredentialsComponent,
        SiteCopyComponent,
        RedirectModalComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SitesBuilderLibModule,
        SbEditorSidebarModule,
        SbEditorToolsModule,
        NgMultiSelectDropDownModule.forRoot()
    ],
    providers: [],
    exports: [
       // SbEditorComponent
    ]
})
export class SbEditorModule {}